module.exports = __webpack_public_path__ + "img/grand-restaurant-3.69f997f1.jpg";